import { ChatWindow } from '../organism';
import { useState, useEffect } from 'react';
import chatIcon from '@/assets/chat-icons/chat-icon.svg';

type ChatWindowShowerProps = {
  incidentId: string;
  autoOpen?: boolean;
};

export const ChatWindowShower = ({ incidentId, autoOpen = false }: ChatWindowShowerProps) => {
  const [isShowingChat, setIsShowingChat] = useState(false);

  useEffect(() => {
    if (autoOpen) {
      setIsShowingChat(true);
    }
  }, [autoOpen]);

  return (
    <div className="fixed bottom-8 right-6 z-[1000] flex flex-col items-end gap-4">
      <div
        className={`mb-2 w-[min(100vw-2rem,420px)] overflow-hidden rounded-xl shadow-[0_8px_24px_rgba(0,0,0,0.15)] ${
          isShowingChat
            ? 'block h-[min(535px,calc(100vh-8rem))] max-h-[75vh]'
            : 'hidden'
        }`}
        aria-hidden={!isShowingChat}
      >
        <ChatWindow incidentId={incidentId} />
      </div>
      <button
        type="button"
        onClick={() => setIsShowingChat((prev) => !prev)}
        className="flex h-[60px] w-[60px] shrink-0 items-center justify-center rounded-full bg-primary2 text-white shadow-[0_4px_12px_rgba(0,0,0,0.2)] transition hover:scale-105 hover:bg-primary2/90 focus:outline-none focus:ring-2 focus:ring-primary2 focus:ring-offset-2"
        aria-label={isShowingChat ? 'Cerrar chat' : 'Abrir chat'}
        aria-expanded={isShowingChat}
      >
        <img src={chatIcon} alt="" className="h-8 w-8" />
      </button>
    </div>
  );
};
